import { hasActivePredicate } from '~/components/AiSearchChips/searchFilterActivity';
import { useStoreActions } from '~/contexts';
import { QueryKeys } from '~/hooks/reactQuery/queryKeys';
import { useQueryState } from '~/hooks/reactQuery/useQueryState';
import { mapSearchRowToDraftSummary } from './drafts-search-row-mapper';
import { useDraftsAiSearchStore } from './useDraftsAiSearchStore';
const EMPTY = [];
const PAGE_LIMIT = 200;
export const useDraftsAiSearchResults = function useDraftsAiSearchResults() {
    let { enabled = true } = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var _ref;
    const { api } = useStoreActions();
    const filter = useDraftsAiSearchStore((s)=>s.filter);
    const searchUnsupported = useDraftsAiSearchStore((s)=>s.searchUnsupported);
    const setError = useDraftsAiSearchStore((s)=>s.setError);
    const applyOrArmMatchCounts = useDraftsAiSearchStore((s)=>s.applyOrArmMatchCounts);
    const isUnsupported = enabled && searchUnsupported;
    const hasSearchableFilter = enabled && filter != null && hasActivePredicate(filter);
    const { data, isFetching, isLoading, refresh } = useQueryState({
        queryKey: [
            QueryKeys.DraftsAiSearchResults,
            filter
        ],
        queryFn: (param)=>{
            let { signal } = param;
            if (filter == null) throw new Error('drafts AI-search query enabled without a filter');
            return api.draft.search({
                filter,
                limit: PAGE_LIMIT,
                signal
            });
        },
        enabled: hasSearchableFilter,
        staleTime: 0,
        keepPreviousData: true,
        onError: (err)=>{
            var _err_response;
            const status = err === null || err === void 0 ? void 0 : (_err_response = err.response) === null || _err_response === void 0 ? void 0 : _err_response.status;
            setError(status === 404 ? 'feature_disabled' : 'search_failed');
        },
        onSuccess: (response)=>{
            var _response_orArmMatchCounts;
            setError(null);
            applyOrArmMatchCounts((_response_orArmMatchCounts = response.orArmMatchCounts) !== null && _response_orArmMatchCounts !== void 0 ? _response_orArmMatchCounts : null);
        }
    });
    const entries = isUnsupported ? undefined : data === null || data === void 0 ? void 0 : data.entries;
    const drafts = Array.isArray(entries) ? entries.map(mapSearchRowToDraftSummary) : EMPTY;
    return {
        drafts,
        isActive: hasSearchableFilter || isUnsupported,
        isFetching,
        isLoading,
        refresh,
        renderedCount: drafts.length,
        totalMatchCount: isUnsupported ? 0 : (_ref = data === null || data === void 0 ? void 0 : data.totalCount) !== null && _ref !== void 0 ? _ref : 0
    };
};
